var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"astrologyhome"},[_c('SidebarAstrology'),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('NavbarAstrology'),_vm._v(" "),_c('div',{staticClass:"content",staticStyle:{"margin-top":"50px"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-753154f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/astrology_ventures/HomeAdmin.vue
// module id = null
// module chunks = 